<div class="my-3 my-md-5">
  <div class="container-fluid">
    <div class="col-sm-6 float-left">
        <h1 class="page-title">TPA Insurance List</h1>
    </div>
    <div class="col-sm-6 float-left add_user_btn">
        <a routerLink="/create-tpa-insurance" class="btn btn-success">
          <i class="fa fa-plus" aria-hidden="true"></i> Add TPA Insurance
      </a>
    </div>

  </div>

  <div class="container-fluid px-4 pt-4 card">
      <!-- <mat-accordion class="example-headers-align" multi>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                      <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                  <div class="row mb-4 mt-4">
                      <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text" (keyup)="loadTpaList(0,perpage)" placeholder="Search" /></div>
                      <div class="col-sm-3">
                          <mat-select  placeholder="Status" (selectionChange)="loadTpaList(0,perpage)" [(ngModel)]="status">
                              <mat-option >All</mat-option>
                              <mat-option value="1">Active</mat-option>
                              <mat-option value="0">In-Active</mat-option>
                          </mat-select>
                      </div>

                  </div>
              </mat-expansion-panel>
      </mat-accordion> -->
      <div class="card">
          <div class="container-fluid row">
              <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading" (click)="loadTpaInsurnaceList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button></div>
              <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
          </div>
          <div class="tableFixHead" style="overflow: scroll">
          <table class="table table-striped">
              <thead>
                  <tr>
                      <th>#</th>
                      <th>Tpa</th>
                      <th>Insurance Comapany</th>
                      <th>Gipsa</th>
                      <th>Active/Inactive</th>
                      <th>Status</th>
                      <th>Action</th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let tpa of tpaInsuranceList;let index = index;">
                      <td >{{(pageIndex*perpage)+index+1}}</td>
                      <td>{{tpa.tpaName}}</td>
                      <td>{{tpa.insuranceCompanyName}}</td>
                      <td>
                        <span *ngIf="tpa.gipsa">Yes</span>
                        <span *ngIf="!tpa.gipsa">No</span>
                      </td>
                      <td>
                        <span class="badge bg-green-light" *ngIf="tpa.status=='1'">Active</span>
                        <span class="badge bg-azure-light" *ngIf="tpa.status=='0'">In-Active</span>
                          <span class="badge bg-red" *ngIf="tpa.status=='2'">Deleted</span>
                      </td>
                      <td *ngIf="myrole=='1' || myrole=='5'">
                          <mat-slide-toggle [checked]="tpa.status=='1'" (change)="onStatusChange($event,tpa.id,index)"></mat-slide-toggle>
                      </td>

                      <td>
                           <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle" type="button" id="{{tpa.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  Action
                              </button>
                              <div class="dropdown-menu" aria-labelledby="{{tpa.id}}">
                                  <a class="dropdown-item" routerLink="/update-tpa-insurance/{{tpa.id}}"><i class="fa fa-pen"></i> Update</a>
                              </div>
                           </div>
                      </td>
                  </tr>
                  <tr *ngIf="loading">
                      <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                  </tr>
                  <tr *ngIf="loaded && !tpaInsuranceList.length">
                      <td colspan="20" ><i class="far fa-frown"></i> TPA insurance not found</td>
                  </tr>
              </tbody>
          </table>
          </div>
          <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
      </div>


        </div>
</div>
